export const headerNav = [
  {
    title: 'Team',
    url: '#team',
  },
  {
    title: 'Menu',
    url: '#menu',
  },
  {
    title: 'Reservation',
    url: '#reservation',
  },
  {
    title: 'Gallery',
    url: '#gallery',
  },
  {
    title: 'Contact',
    url: '#contact',
  },
];

export const teamText = [
  {
    title: 'Sungjae Anh',
    titleKr: '안성재',
    desc: `Past memories from childhood and</br>
        diverse experiences gained from working</br>
        in various restaurants have become sources of inspiration.</br>
        Based on a deep understanding of ingredients and endless curiosity,</br>
        Sung Anh started in San Francisco</br>
        and now operates Mosu Seoul and Mosu Hong Kong.`,
    descKr: `어린 시절의 소중한 추억과 여러 레스토랑에서</br>
        쌓은 다양한 경험이 영감이 되어,</br>
        재료에 대한 깊은 이해와 끝없는 호기심을 바탕으로</br>
        샌프란시스코에서 출발하여</br>
        모수 서울과 모수 홍콩을 운영하고 있습니다.`,
  },
  {
    title: 'Jinboem Kim',
    titleKr: '김진범',
    desc: `Starting with winning the SOPEXA<br/>
        Korean Sommelier competition,<br/>
        he achieved numerous awards<br/>
        in various competitions and<br/>
        gained diverse experience.<br/>
        <br/>
        He began his wine career<br/>
        with the sommelier team<br/>
        at Sheraton Grand Walkerhill Seoul hotel,<br/>
        and participated as an opening member<br/>
        at Mosu Seoul in 2017.<br/>
        Currently,<br/>
        he oversee both the FOH team and beverage team.`,
    descKr: `SOPEXA 한국 소믈리애 대회 우승을 시작으로<br/>
        각종 대회 입상과 다양한 경험을 갖고 있습니다. <br/>
        <br/>
        서울 쉐라톤 그랜드 워커힐 호텔 소믈리애 팀에서<br/>
        와인 업무를 시작했고<br/>
        2017년 모수 서울 오프닝 멤버로 참여해<br/>
        현재까지 FOH팀과 음료팀을 총괄하고 있습니다.`,
  },
  {
    title: 'Jongil Oh',
    titleKr: '오종일',
    desc: `Chef Oh began his culinary journey<br/>
        after winning first place<br/>
        in a cooking competition for military chefs.<br/>
        <br/>
        He honed his skills<br/>
        at an Italian restaurant and at Merciel,<br/>
        and in 2017, he was recruited<br/>
        as an opening member of Mosu Seoul.<br/>
        <br/>
        Currently he is a head chef, overseeing the kitchen.`,
    descKr: `조리병 요리대회 1위를 계기로<br/>
        요리의 길에 입문하게 되었습니다.<br/>
        <br/>
        이탈리안 레스토랑과 메르씨엘에서 실력을 쌓았고<br/>
        2017년 모수 서울 오프닝 멤버로 영입되어<br/>
        현재는 헤드셰프로 주방을 책임지고 있습니다. `,
  },
];

export const reservationText = [
  {
    title: 'Information',
    titleKr: '안내',
    desc: `Mosu Seoul operates on a reservation only basis.<br/>
        Reservation can be made through Catchtable.<br/>
        Reservations are not available via phone, e-mail or direct message.`,
    descKr: `모수서울은 전석 사전 예약제로 운영됩니다.<br/>
        예약은 캐치테이블을 통해 가능하고,<br/>
        전화, 이메일, SNS메세지로는 불가합니다.<br/>
        대관 및 기타 사항은 전화 혹은 이메일로 문의주시길 바랍니다.`,
  },
  {
    title: 'Deposit Refund policy ',
    titleKr: '예약금 환불 규정 안내',
    desc: `Regarding cancellation and change of reservation<br/>
        3 days before : 100% refund<br/>
        2 days before, 1 day before or same day : No refund`,
    descKr: `3일 전 취소 : 100% 환불<br/>
        이후의 취소 혹은 인원/날짜 변경 : 환불불가`,
  },
  // 추가 항목
];
